<template>
  <AppLayout>
    <template #header>
      <PageHeadingWithActionsAndBreadcrumbs
        :title="`Holds for ${props.plane.tail_number}`"
        :breadcrumbs="getFirstBreadcrumbLevel()"
      />
    </template>

    <div class="space-y-4">
      <HoldCard v-for="hold in props.holds" :key="hold.id" :hold="hold" />
    </div>
  </AppLayout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageHeadingWithActionsAndBreadcrumbs from '@/Common/Headings/PageHeadings/PageHeadingWithActionsAndBreadcrumbs.vue'
import HoldCard from './HoldCard.vue'

const props = defineProps({
  plane: Object,
  holds: Array,
})

function getFirstBreadcrumbLevel() {
  return [
    {
      title: 'Plane',
      href: route('planes.show', props.plane),
    },
  ]
}
</script>
